import React, { useEffect, useState } from "react";
import "./searchProductList.scss";
import { useParams } from "react-router-dom";
import TwoBreadcrumb from "../../components/breadcrumbs/TwoBreadcrumb";
import {
  Grid,
  Divider,
  useMediaQuery,
  Pagination,
  Paper,
  Chip,
  Avatar,
} from "@mui/material";
import SearchFilter from "./searchFilter/SearchFilter";
import productStore from "../../store/productStore";
import ProductCard from "../../components/productCard/ProductCard";
import { SortOptions } from "../../constant";
import SmallProductCard from "../../components/smallProductCard/SmallProductCard";
import FilterDialog from "../../components/filterDialog/FilterDialog";

// Icon
import ArrowDropDownRoundedIcon from "@mui/icons-material/ArrowDropDownRounded";
import FilterAltRoundedIcon from "@mui/icons-material/FilterAltRounded";
import filterStore, {
  defaultEndSlice,
  defaultEndingPrice,
  defaultStartSlice,
  defaultStartingPrice,
} from "../../store/filterStore";
import SmallProductCardSkeleton from "../../components/smallProductCard/SmallProductCardSkeleton";
import ProductCardSkeleton from "../../components/productCard/ProductCardSkeleton";

const SearchProductList = () => {
  const params = useParams();
  const ProductStore = productStore();
  const FilterStore = filterStore();
  const [isLoading, setIsLoading] = useState(true);

  const productLoading = [1, 2, 3, 4];

  const maxWidth_550 = useMediaQuery("(max-width:550px)");
  const maxWidth_900 = useMediaQuery("(max-width:900px)");
  const maxWidth_1000 = useMediaQuery("(max-width:1000px)");
  const maxWidth_1280 = useMediaQuery("(max-width:1280px)");
  const maxWidth_1440 = useMediaQuery("(max-width:1440px)");
  const [noData, setNoData] = useState(false);

  const [openFilterDialog, setOpenFilterDialog] = useState(false);

  const handleChange = (event, newValue) => {
    FilterStore.setPriceValue({ value: newValue });
    FilterStore.setPriceRadio({ value: "" });
  };

  useEffect(() => {
    if (FilterStore.filterProduct) {
      if (FilterStore.filterProduct.length) {
        setNoData(false);
        const count = FilterStore.filterProduct.length / defaultEndSlice;
        FilterStore.setPageCount({ value: parseInt(Math.ceil(count)) });
      }
    }
    FilterStore.setPage({ value: 1 });
    FilterStore.setStartSlice({ value: defaultStartSlice });
    FilterStore.setEndSlice({ value: defaultEndSlice });
  }, [FilterStore.filterProduct]);

  useEffect(() => {
    window.scrollTo({ top: 0 });
    FilterStore.setSelectSort({ value: "What's New" });

    if (ProductStore.mProduct) {
      if (params.searchID) {
        FilterStore.setCategoryID({ value: null });
        const data = [];
        ProductStore.mProduct.filter((item) => {
          item.tagID.filter((tag) => {
            if (tag === params.searchID && item.publish) {
              data.push(item);
            }
          });
        });

        FilterStore.setFilterProduct({ data: data.slice(0).reverse() });
        FilterStore.setMainProduct({ data: data.slice(0).reverse() });
        // FilterStore.setFilterProduct(ProductStore.mProduct.slice(0).reverse());
        // FilterStore.setMainProduct(ProductStore.mProduct.slice(0).reverse());
        if (!data.length) {
          setNoData(true);
        }
        setIsLoading(false);

        if (params.searchID !== FilterStore.searchID) {
          resetFilters();
        }
        FilterStore.setSearchID({ value: params.searchID });
      }

      if (params.categoryID) {
        FilterStore.setSearchID({ value: null });
        const data = [];

        ProductStore.mProduct.filter((item) => {
          if (item.categoryID === params.categoryID && item.publish) {
            data.push(item);
          }
        });

        FilterStore.setFilterProduct({ data: data.slice(0).reverse() });
        FilterStore.setMainProduct({ data: data.slice(0).reverse() });
        // FilterStore.setFilterProduct(ProductStore.mProduct.slice(0).reverse());
        // FilterStore.setMainProduct(ProductStore.mProduct.slice(0).reverse());
        if (!data.length) {
          setNoData(true);
        }
        setIsLoading(false);

        if (params.categoryID !== FilterStore.categoryID) {
          resetFilters();
        }
        FilterStore.setCategoryID({ value: params.categoryID });
      }
    }
  }, [params.searchID, params.categoryID, ProductStore.mProduct]);

  const resetFilters = () => {
    FilterStore.setResetAll({ value: false });
    FilterStore.setResetPrice({ value: false });
    FilterStore.setPriceValue({
      value: [defaultStartingPrice, defaultEndingPrice],
    });
    FilterStore.setPriceRadio({ value: "" });
    FilterStore.setResetColor({ value: false });
    FilterStore.setSelectedColors({ value: [] });
    FilterStore.setResetSize({ value: false });
    FilterStore.setSelectedSizes({ value: [] });
    FilterStore.setResetGender({ value: false });
    FilterStore.setSearchGender({ value: "" });
  };

  const whatsNew = () => {
    const data = [...FilterStore.filterProduct].sort((a, b) => {
      const A = new Date(a.created_at);
      const B = new Date(b.created_at);
      return B - A;
    });
    FilterStore.setFilterProduct({ data });
  };

  useEffect(() => {
    switch (FilterStore.selectSort) {
      case "What's New":
        if (FilterStore.filterProduct) {
          if (FilterStore.filterProduct.length) {
            if (FilterStore.whatsNew) {
              whatsNew();
            }
          }
        }
        break;
      case "Price: High to Low":
        priceHighToLow();
        FilterStore.setWhatsNew({ value: true });
        break;
      case "Price: Low to High":
        priceLowToHigh();
        FilterStore.setWhatsNew({ value: true });
        break;
      // case "Customer Rating":
      //   whatsNew();
      //   FilterStore.setWhatsNew({ value: true });
      //   break;
      default:
        break;
    }
  }, [FilterStore.selectSort]);

  const priceLowToHigh = () => {
    const lth = [...FilterStore.filterProduct].sort((a, b) => {
      const A = a.salePrice ? a.salePrice : a.regularPrice;
      const B = b.salePrice ? b.salePrice : b.regularPrice;
      return A - B;
    });

    FilterStore.setFilterProduct({ data: lth });
  };

  const priceHighToLow = () => {
    const htl = [...FilterStore.filterProduct].sort((a, b) => {
      const A = a.salePrice ? a.salePrice : a.regularPrice;
      const B = b.salePrice ? b.salePrice : b.regularPrice;
      return B - A;
    });
    FilterStore.setFilterProduct({ data: htl });
  };

  useEffect(() => {
    if (FilterStore.searchGender) {
      if (!FilterStore.resetGender) {
        FilterStore.setResetGender({ value: true });
        FilterStore.setResetAll({ value: true });
      } else {
        allSetFilter();
      }
    } else {
      FilterStore.setResetGender({ value: false });
    }
  }, [FilterStore.searchGender]);

  useEffect(() => {
    if (
      FilterStore.priceValue[0] !== defaultStartingPrice ||
      FilterStore.priceValue[1] !== defaultEndingPrice
    ) {
      if (!FilterStore.resetPrice) {
        FilterStore.setResetPrice({ value: true });
        FilterStore.setResetAll({ value: true });
      } else {
        allSetFilter();
      }
    }
  }, [FilterStore.priceValue]);

  useEffect(() => {
    if (FilterStore.selectedColors.length) {
      if (!FilterStore.resetColor) {
        FilterStore.setResetColor({ value: true });
        FilterStore.setResetAll({ value: true });
      } else {
        allSetFilter();
      }
    } else {
      FilterStore.setResetColor({ value: false });
    }
  }, [FilterStore.selectedColors]);

  useEffect(() => {
    if (FilterStore.selectedSizes.length) {
      if (!FilterStore.resetSize) {
        FilterStore.setResetSize({ value: true });
        FilterStore.setResetAll({ value: true });
      } else {
        allSetFilter();
      }
    } else {
      FilterStore.setResetSize({ value: false });
    }
  }, [FilterStore.selectedSizes]);

  useEffect(() => {
    if (
      FilterStore.resetPrice ||
      FilterStore.resetColor ||
      FilterStore.resetSize ||
      FilterStore.resetGender
    ) {
      allSetFilter();
    }
  }, [
    FilterStore.resetPrice,
    FilterStore.resetColor,
    FilterStore.resetSize,
    FilterStore.resetGender,
  ]);

  const allSetFilter = () => {
    let finalData = [];
    if (FilterStore.resetPrice) {
      const data = FilterStore.mainProduct.filter((item) => {
        if (item.salePrice !== null) {
          if (
            item.salePrice >= FilterStore.priceValue[0] &&
            item.salePrice <= FilterStore.priceValue[1]
          ) {
            return item;
          }
        } else {
          if (
            item.regularPrice >= FilterStore.priceValue[0] &&
            item.regularPrice <= FilterStore.priceValue[1]
          ) {
            return item;
          }
        }
      });
      finalData = data;
    } else {
      finalData = FilterStore.mainProduct;
    }

    if (FilterStore.searchGender) {
      const genderData = [];
      finalData.filter((item) => {
        item.gender.map((g) => {
          if (g === FilterStore.searchGender) {
            genderData.push(item);
          }
        });
      });
      finalData = genderData;
    }

    if (FilterStore.selectedColors.length && FilterStore.resetColor) {
      const colorData = [];
      finalData.filter((item) => {
        item.productColors.map((color) => {
          for (let i = 0; i < FilterStore.selectedColors.length; i++) {
            if (FilterStore.selectedColors[i] === color) {
              if (colorData.length) {
                let duplicate = false;
                colorData.filter((cd) => {
                  if (cd._id === item._id) {
                    duplicate = true;
                  }
                });

                if (!duplicate) colorData.push(item);
              } else {
                colorData.push(item);
              }
            }
          }
        });
      });
      finalData = colorData;
    }

    if (FilterStore.selectedSizes.length && FilterStore.resetSize) {
      const sizeData = [];
      finalData.filter((item) => {
        item.productSizes.map((size) => {
          for (let i = 0; i < FilterStore.selectedSizes.length; i++) {
            if (FilterStore.selectedSizes[i] === size) {
              if (sizeData.length) {
                let duplicate = false;
                sizeData.filter((sd) => {
                  if (sd._id === item._id) {
                    duplicate = true;
                  }
                });

                if (!duplicate) sizeData.push(item);
              } else {
                sizeData.push(item);
              }
            }
          }
        });
      });
      finalData = sizeData;
    }

    if (!finalData.length) {
      setNoData(true);
    } else {
      setNoData(false);
    }
    FilterStore.setFilterProduct({ data: finalData });
  };

  return (
    <div className="search-product-list">
      <div className="breadcrumb-container">
        <TwoBreadcrumb
          activeName={
            params.searchID
              ? `Showing results for: ${params.search}`
              : `${params.categoryName}`
          }
        />
      </div>
      <Grid container className="product-list-container" spacing={2}>
        <Grid
          item
          lg={2.5}
          md={3}
          display={{ xs: "none", lg: "block", sm: "none", md: "block" }}
          className="leftside-filter"
        >
          <SearchFilter
            handleChange={handleChange}
            resetFilters={resetFilters}
            allSetFilter={allSetFilter}
          />
        </Grid>
        <Grid
          item
          lg={9.5}
          md={9}
          sm={12}
          xs={12}
          className="rightside-product-listing"
        >
          <div className="rightside-product-listing-container">
            <div className="sort-filter">
              <div className="sort-filter-container">
                <div className="selected-filter">
                  <p>Sort by: {FilterStore.selectSort}</p>
                  <ArrowDropDownRoundedIcon />
                </div>
                <div className="filter-options">
                  <Divider sx={{ mt: "10px" }} />
                  {SortOptions &&
                    SortOptions.map((option) => (
                      <div
                        className={`filter-option ${
                          option === FilterStore.selectSort && "active"
                        }`}
                        key={option}
                        onClick={() => {
                          FilterStore.setSelectSort({ value: option });
                        }}
                      >
                        {option}
                      </div>
                    ))}
                </div>
              </div>
              {maxWidth_900 && (
                <div className="mobile-filter">
                  <Chip
                    variant="outlined"
                    avatar={
                      <Avatar>
                        <FilterAltRoundedIcon fontSize="small" />
                      </Avatar>
                    }
                    label="Filters"
                    onClick={() => setOpenFilterDialog(true)}
                  />
                </div>
              )}
            </div>

            {isLoading ? (
              <Grid
                container
                spacing={maxWidth_550 ? 1 : 2}
                mt={5}
                className="grid-container"
              >
                {productLoading &&
                  productLoading.map((item) => (
                    <Grid item lg={3} md={4} sm={6} xs={6} key={item}>
                      <div className="listing-of-single-card">
                        {maxWidth_550 ? (
                          <SmallProductCardSkeleton height="180px" />
                        ) : (
                          <ProductCardSkeleton
                            height={
                              maxWidth_900
                                ? "350px"
                                : maxWidth_1000
                                ? "270px"
                                : maxWidth_1280
                                ? "300px"
                                : maxWidth_1440
                                ? "300px"
                                : "350px"
                            }
                          />
                        )}
                      </div>
                    </Grid>
                  ))}
              </Grid>
            ) : (
              <div className="product-listing">
                {noData && (
                  <div className="has-no-data-found">
                    <Paper className="paper">No Product Found</Paper>
                  </div>
                )}

                <Grid
                  container
                  spacing={maxWidth_550 ? 1 : 2}
                  className="grid-container"
                >
                  {FilterStore.filterProduct &&
                    FilterStore.filterProduct
                      .slice(FilterStore.startSlice, FilterStore.endSlice)
                      .map((item) => (
                        <Grid item lg={3} md={4} sm={6} xs={6} key={item._id}>
                          <div className="listing-of-single-card">
                            {maxWidth_550 ? (
                              <SmallProductCard item={item} height="180px" />
                            ) : (
                              <ProductCard
                                item={item}
                                height={
                                  maxWidth_900
                                    ? "350px"
                                    : maxWidth_1000
                                    ? "270px"
                                    : maxWidth_1280
                                    ? "300px"
                                    : maxWidth_1440
                                    ? "300px"
                                    : "350px"
                                }
                              />
                            )}
                          </div>
                        </Grid>
                      ))}
                </Grid>
              </div>
            )}

            {FilterStore.filterProduct &&
              FilterStore.filterProduct.length !== 0 && (
                <div className="pagination">
                  <Pagination
                    count={FilterStore.pageCount}
                    // showFirstButton
                    // showLastButton
                    page={FilterStore.page}
                    boundaryCount={1}
                    siblingCount={1}
                    onChange={(event, value) => {
                      FilterStore.setPage({ value });
                      FilterStore.setStartSlice({
                        value: parseInt(
                          value * defaultEndSlice - defaultEndSlice
                        ),
                      });
                      FilterStore.setEndSlice({
                        value: value * defaultEndSlice,
                      });
                      window.scrollTo({ top: 50 });
                    }}
                  />
                </div>
              )}
          </div>
        </Grid>
      </Grid>
      <FilterDialog
        open={openFilterDialog}
        setOpenFilterDialog={setOpenFilterDialog}
      >
        <SearchFilter
          handleChange={handleChange}
          resetFilters={resetFilters}
          allSetFilter={allSetFilter}
        />
      </FilterDialog>
    </div>
  );
};

export default SearchProductList;
